/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {  DataGridCustom, Grid, Table, Button } from '../../../components/index';
// import { stringToData } from '../../../utils/helpers';
import { recuperarAnosQuePossuemAlgumaRemuneracao } from '../../../utils/ctcHelpers';
import { obterMesDaCompetencia, obterAnoDaCompetencia } from '../../../utils/helpers';
import * as listUtils from '../../../utils/listsSelect';
import ModalTemposERemuneracoes from './ModalTemposERemuneracoes';
import {
  trataMensagensErro,
} from '../../../utils/requests';
import ModalExibirModalRemuneracoesPreenchidas from './ModalExibirRemuneracoesPreenchidas';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';

const pemissoesAcaoPrincipal = ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
const VAZIO = '';
const ID_LISTA_ATIVIDADE = 1;
// afastamentos virou deducoes
const ID_LISTA_AFASTAMENTOS = 2;
const ID_LISTA_TEMPOS_CERTIFICADOS = 3;
const ID_LISTA_TEMPOS_ESPECIAIS = 4;
const ID_LISTA_REMUNERACOES = 5;

class MultiplasAtividades extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    ctcAtividadeAfastamento: {
      dtInicio: null,
      dtFim: null,
      tipo: null,
      operacao: 0,
    },
    ctcAtividadeTempoCertificado: {
      dtInicio: null,
      dtFim: null,
      tempoLiquidoCertificado: null,
      indiceDestinatario: null,
      operacao: 0,
      nomeDestinacao: null,
    },
    ctcAtividadeTempoEspecial: {
      dtInicio: null,
      dtFim: null,
      tipo: null,
      operacao: 0,
    },
    anoEscolhido: null,
    showModal: false,
    remuneracoesPreenchidas: [],
    remuneracoesHistory: [],
    valorRemuneracao: null,
    operacaoRemuneracao: null,
    anosQuePossuemAlgumaRemuneracao: [],
    showModalExibirModalRemuneracoesPreenchidas: false,
  })
  
  componentDidMount() {
    this.carregarRemuneracoesCadastradas();
  }

  determinarObjetoAtividade = () => {
    const id = this.props.id;
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        let { ctcAtividadeAfastamento } = { ...this.state };
        return ctcAtividadeAfastamento;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        let { ctcAtividadeTempoCertificado } = { ...this.state };
        return ctcAtividadeTempoCertificado;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        let { ctcAtividadeTempoEspecial } = { ...this.state };
        return ctcAtividadeTempoEspecial;
      default:
        break;
    }
  }

  escolherLista = () => {
    const id = this.props.id;
    let lista = [];
    let { afastamentos, temposCertificados, temposEspeciais, remuneracoes } = { ...this.props.stateAtividade.ctcAtividade };
    const { anosQuePossuemAlgumaRemuneracao } = { ...this.props.stateAtividade };
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        if(afastamentos !== null && afastamentos !== undefined) {
          lista = afastamentos
        } else {
          afastamentos = [];
          lista = afastamentos;
        }
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        if(temposCertificados !== null && temposCertificados !== undefined) {
          lista = temposCertificados
        } else {
          temposCertificados = [];
          lista = temposCertificados;
        }
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        if(temposEspeciais !== null && temposEspeciais !== undefined) {
          lista = temposEspeciais
        } else {
          temposEspeciais = [];
          lista = temposEspeciais;
        }
        break;        
      case ID_LISTA_REMUNERACOES:
        if(remuneracoes) {
          lista = anosQuePossuemAlgumaRemuneracao;
          break;
        }
      break;
      default:
        break;
    }
    return lista;
  }

  resetAtividades = () => {
    const id = this.props.id;
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        this.setState({
          ctcAtividadeAfastamento: {
            dtInicio: null,
            dtFim: null,
            tipo: null,
          },
        }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        this.setState({
          ctcAtividadeTempoCertificado: { 
            dtInicio: null,
            dtFim: null,
            tempoLiquidoCertificado: null,
            indiceDestinatario: null,
            nomeDestinacao: null,
          },
        }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        this.setState({
          ctcAtividadeTempoEspecial: { 
            dtInicio: null,
            dtFim: null,
            tipo: null
          },
        }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_REMUNERACOES:
        let {remuneracoesPreenchidas} = { ...this.state };
        let {remuneracoesHistory} = { ...this.state };

        remuneracoesPreenchidas = [];
        if (remuneracoesHistory === undefined || remuneracoesHistory === null ) {
          remuneracoesHistory = [];
        }

        remuneracoesHistory.forEach((item) => {
          let competencia = '';
          if(item.mes === undefined && item.ano === undefined){
            competencia = item.competencia;
          } else {
            competencia = this.formatarCompetencia(`${item.mes}-${item.ano}`)
          }
          let retorno = {
            competencia: competencia,
            valor: item.valor,
          };
          remuneracoesPreenchidas.push(retorno);
        });

        this.setState({
          operacaoRemuneracao: null,
          remuneracoesPreenchidas,
        }, this.exibirModalTemposEremuneracoes());
      break;
      default:
        break;
    }
  }

  exibirModalTemposEremuneracoes = () => {
    const { ctcAtividade } = { ...this.props };
    let { ctc } = { ...this.props.statePrincipal };
    const { id } = { ...this.props };
    const dataAtual = new Date();
    // let { destinacoesTempoCertificado } = { ...this.props.statePrincipal };
    let dtInicio = null;
    let dtFim = null;
    let possuiDataInicio = (ctcAtividade.dtInicio !== null && ctcAtividade.dtInicio !== '');
    let possuiDataFim = (ctcAtividade.dtFim !== null && ctcAtividade.dtFim !== '');
    let possuiPeriodoCadastrado = (possuiDataInicio && possuiDataFim);
    let dataFimMaiorQueDataInicio = null;
    let dataFimMaiorQueDataHoje = null;
    let mensagem = '';

    if (possuiPeriodoCadastrado) {
      dtInicio = moment(ctcAtividade.dtInicio, 'DD/MM/YYYY');
      dtFim = moment(ctcAtividade.dtFim, 'DD/MM/YYYY');
      dataFimMaiorQueDataInicio = dtFim.isSameOrAfter(dtInicio);
      dataFimMaiorQueDataHoje = moment(ctcAtividade.dtFim, 'DD/MM/YYYY').toDate() > dataAtual;
    } else {
      mensagem = 'É necessário preencher a data de início e a data de fim da atividade na aba "Período de Contribuição"';
    }

    if(dataFimMaiorQueDataInicio === false) {
      mensagem = 'O período é inválido. A data de início de período deve ser menor que a data de fim do período.';
    }

    if (dataFimMaiorQueDataHoje) {
      mensagem = 'O período é inválido. A data de fim de período não deve ser maior que a data atual.';
    }

    if (id === ID_LISTA_TEMPOS_CERTIFICADOS) {
      this.props.montarListaDestinacaoTempoCertificado(ctc.destinacoes);
    }

    // se o periodo for valido, exibir o modal
    if (possuiPeriodoCadastrado && dataFimMaiorQueDataInicio === true && dataFimMaiorQueDataHoje == false) {
      this.setState({showModal: !this.state.showModal });
    } else {
      trataMensagensErro([mensagem]);
    }
  }

  formatarCompetencia = (competencia) => {
    let retorno = competencia;
    if (competencia.length !== 7) {
      retorno = `0${competencia}`;
    }
    return retorno;
  };

  popularObjeto = (row, idOperacao) => {
    const id = this.props.id;
    let retorno = null;
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        const { afastamentos } = { ...this.props.ctcAtividade };
        retorno = {
          dtInicio: afastamentos[row] ? afastamentos[row].dtInicio : null,
          dtFim: afastamentos[row] ? afastamentos[row].dtFim : null,
          tipo: afastamentos[row] ? afastamentos[row].tipo : null,
          indice: afastamentos[row] ? afastamentos[row].indice : null,
          tempoLiquidoCertificado: this.props.calcularTempoAfastamento(afastamentos[row].dtInicio, afastamentos[row].dtFim),
          operacao: idOperacao,
        };
        return retorno;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        const { temposCertificados } = { ...this.props.ctcAtividade };
        retorno = {
          dtInicio: temposCertificados[row] ? temposCertificados[row].dtInicio : null,
          dtFim: temposCertificados[row] ? temposCertificados[row].dtFim : null,
          tempoLiquidoCertificado: this.props.calcularTempoLiquidoCertificado(temposCertificados[row].dtInicio, temposCertificados[row].dtFim , true, null),
          indiceDestinatario: temposCertificados[row] ? temposCertificados[row].indiceDestinatario : null,
          indice: temposCertificados[row] ? temposCertificados[row].indice : null,
          operacao: idOperacao,
        };
        return retorno;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        const { temposEspeciais } = { ...this.props.ctcAtividade };
        retorno = {
          dtInicio: temposEspeciais[row] ? temposEspeciais[row].dtInicio : null,
          dtFim: temposEspeciais[row] ? temposEspeciais[row].dtFim : null,
          tipo: temposEspeciais[row] ? temposEspeciais[row].tipo : null,
          indice: temposEspeciais[row] ? temposEspeciais[row].indice : null,
          tempoLiquidoCertificado: this.props.calcularTempoEspecial(temposEspeciais[row].dtInicio, temposEspeciais[row].dtFim),
          operacao: idOperacao,
        };
        return retorno;
      case ID_LISTA_REMUNERACOES:
        const { remuneracoes } = { ...this.props.ctcAtividade };
        const { remuneracoesPreenchidas } = { ...this.state };
        const { acao } = { ...this.props.statePrincipal };
        let preenchidas = [];
        if ( acao === 'novo') {
          preenchidas = remuneracoes;
        }

        if(['editar-rascunho', 'revisar-ctc', 'detalhar-ctc', 'detalhar-ctc-invalida'].includes(acao)) {
          preenchidas = remuneracoesPreenchidas;
          if (remuneracoesPreenchidas.length === 0) {
            preenchidas = remuneracoes;
          }
        }

        let competencia = '';
        preenchidas.forEach((item) => {
          if((item.mes === undefined && item.ano === undefined) && item.competencia !== undefined) {
            const mes = obterMesDaCompetencia(item.competencia, '-');
            const ano = obterAnoDaCompetencia(item.competencia, '-');
            competencia = this.formatarCompetencia(`${mes}-${ano}`);
          } else{
            competencia = this.formatarCompetencia(`${item.mes}-${item.ano}`);
          }
          retorno = {
            competencia: competencia,
            valor: item.valor,
          };
          if(remuneracoesPreenchidas.indexOf('-') !== -1) {
            const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === retorno.competencia ));
            if (index === -1) {
              remuneracoesPreenchidas.push(retorno);
            }
          }
        });
        // SE CONTINUAR SENDO VAZIO.
        if (remuneracoesPreenchidas.length === 0) {
          if (['editar-rascunho', 'revisar-ctc', 'detalhar-ctc', 'detalhar-ctc-invalida'].includes(acao)) {
            preenchidas.forEach((item) => {
              competencia = this.formatarCompetencia(`${item.mes}-${item.ano}`);
              retorno = {
                competencia: competencia,
                valor: item.valor,
              };
              remuneracoesPreenchidas.push(retorno);
            });
          }
        }

        return remuneracoesPreenchidas;
      default:
        break;
    }
  }

  apagarRemuneracoesPreenchidas = (ano) => {
    let { remuneracoesPreenchidas } = { ...this.state };
    for (var i = 0; i < remuneracoesPreenchidas.length; i++) {
      var item = remuneracoesPreenchidas[i];
      if (ano === (Number(item.competencia.split('-')[1]))) {
        remuneracoesPreenchidas.splice(i--, 1);
      }
    }
    this.props.handleChange({ value: remuneracoesPreenchidas, isValid: true }, 'remuneracoesPreenchidas');
  }

  deleteItem = (row) => {
    const id = this.props.id;
    if (![ID_LISTA_ATIVIDADE].includes(id)) { // 1 é a lista de atividades.
      let lista = this.escolherLista();
      if (id !== ID_LISTA_REMUNERACOES) { // se o id nao for 5, carregar o objeto.
        const atividadeExcluir = this.popularObjeto(row, 3);
        this.setState({ atividade: atividadeExcluir });
      }
      switch (id) {
        case ID_LISTA_TEMPOS_CERTIFICADOS:
          this.gerenciarDestinacao(lista, 3);
          break;
        case ID_LISTA_REMUNERACOES:
          const ano = this.props.stateAtividade.anosQuePossuemAlgumaRemuneracao[row].ano;
          this.apagarRemuneracoesPreenchidas(ano);          
          break;
        default:
          break;
      }
      lista.splice(row, 1);
      this.alteraListaAposExclusao(lista);
    } else {
      this.props.handleExcluirAtividade(row);
    }
  }

  popularAtividadesAlteracao = (atividadeAlteracao) => {
    const id = this.props.id;
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        this.setState({ ctcAtividadeAfastamento: atividadeAlteracao }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        this.setState({ ctcAtividadeTempoCertificado: atividadeAlteracao }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        this.setState({ ctcAtividadeTempoEspecial: atividadeAlteracao }, this.exibirModalTemposEremuneracoes());
      break;
      case ID_LISTA_REMUNERACOES:
        this.setState({
          remuneracoesPreenchidas: atividadeAlteracao,
          operacaoRemuneracao: 2,
        }, this.exibirModalTemposEremuneracoes());
      break;
      default:
        break;
    }
  }

  alterarItem = (row) => {
    const id = this.props.id;
    if (![ID_LISTA_ATIVIDADE].includes(id)) {
      this.popularAtividadesAlteracao(this.popularObjeto(row, 2));
      if (id === ID_LISTA_REMUNERACOES && (this.props.stateAtividade.anosQuePossuemAlgumaRemuneracao)) {
        const ano = this.props.stateAtividade.anosQuePossuemAlgumaRemuneracao[row].ano;
        this.setState({ anoEscolhido: ano });
      }
    } else {
      this.props.handleCarregarAlteracaoAtividade(row);
    }
  }

  detalharItem = (row) => {
    const id = this.props.id;
    if (![ID_LISTA_ATIVIDADE].includes(id)) {
      this.popularAtividadesAlteracao(this.popularObjeto(row, 2));
    } else {
      this.props.handleCarregarVisualizacaoAtividade(row);
    }
  }

  createActionColumn = index => (
    <React.Fragment>
      {this.exibirBotaoAlterar() &&
        <Button
          hint="Alterar"
          icon="ico-pencil"
          mini
          onClick={() => this.alterarItem(index)}
        />
      }
      {this.exibirBotoesPadrao() &&
        <Button
          className="dtp-inverse"
          hint="Excluir"
          icon="ico-hourglass-minus"
          mini
          onClick={() => this.deleteItem(index)}
        />
      }
      {this.exibirBotaoDetalhar() &&
        <Button
          hint="Detalhar"
          icon="ico-magnifier"
          mini
          onClick={() => this.detalharItem(index)}
          disabled={(this.props.desabilitarBotaoAlterar === index) || this.props.desabilitarListaBotoes}
        />
      }
    </React.Fragment>
  );

  // exibir o botao se o id atual for 5 e a data inicio atv for maior do que 01/07/1994 e a data fim atv for maior do que 01/07/1994.
  verificaExibicaoBotaoIncluirRemuneracoes = (id) => {
    const { dataInicioAtividadeMenorQue1994 } = { ...this.props.stateAtividade };
    const { dataFimAtividadeMenorQue1994 } = { ...this.props.stateAtividade };
    
    if (id === ID_LISTA_REMUNERACOES) {
      if (dataInicioAtividadeMenorQue1994 === true && dataFimAtividadeMenorQue1994 === true) {
        return false;
      } else if (dataInicioAtividadeMenorQue1994 === true && dataFimAtividadeMenorQue1994 === false) {
        return true;
      }else {
        return (!this.exibirBotaoDetalhar());
      }
    } else {
      return (!this.exibirBotaoDetalhar());
    }
  }

  verificaExibicaoMensagemAproveitamentoRemuneracoes = (id) => {
    const { dataInicioAtividadeMenorQue1994 } = { ...this.props.stateAtividade };
    const { dataFimAtividadeMenorQue1994 } = { ...this.props.stateAtividade };
    if(id === ID_LISTA_REMUNERACOES) {
      if (dataInicioAtividadeMenorQue1994 === true && dataFimAtividadeMenorQue1994 === true) {
        return true;
      } else if (dataInicioAtividadeMenorQue1994 === true && dataFimAtividadeMenorQue1994 === false) {
        return true;
      }
    } else {
      return false;
    }
  }

  formatarMensagem = (mensagem) => {
    return (
      <div
        className='mensagemDataInicioAtividadeMenorQue1994'
        style={{
          textAlign: 'center',
          verticalAlign: 'center',
          fontSize: '16px',
          padding: '27px 5px 5px 5px',
          width: 600,
        }}
      >
        {mensagem}
      </div>
    );
  }

  exibirMensagemAproveitamentoRemuneracoes = () => {
    return (
      this.formatarMensagem('Somente serão consideradas remunerações a partir de 01/07/1994.')
    );
  }

  createCustomInsertButton = () => {
    let hint = '';
    const id = this.props.id;
    const { exibirBotaoIncluirInicial } = { ...this.props.stateAtividade };
    switch (id) {
      case ID_LISTA_ATIVIDADE:
        hint = 'Incluir atividades';
        break;
      case ID_LISTA_AFASTAMENTOS:
        hint = 'Incluir deduções';
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        hint = 'Incluir tempo certificados';
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        hint = 'Incluir tempo especiais';
        break;
      case ID_LISTA_REMUNERACOES:
        hint = 'Incluir / Atualizar remunerações';
        break;
      default:
        break;
    }

    return (
      <ProtectedItem allowedPermissions={pemissoesAcaoPrincipal}>
          {(this.verificaExibicaoBotaoIncluirRemuneracoes(id)) ?
            <React.Fragment>
              <div>
                <Grid cols="2 2 2 2">
                  <Button
                    className="dtp-primary left"
                    onClick={exibirBotaoIncluirInicial ? this.showModalAtividade : this.exibirModalTemposEremuneracoes}
                    hint={hint}
                    icon='ico-plus'
                  />
                </Grid>
              </div>
            </React.Fragment>
          : '' }
          {(this.verificaExibicaoMensagemAproveitamentoRemuneracoes(id)) ?
            <React.Fragment>
              <div>
                <Grid cols="10 10 10 10">
                  {this.exibirMensagemAproveitamentoRemuneracoes()}
                </Grid>
              </div>
            </React.Fragment>
          : '' }
      </ProtectedItem>
    );
  }

  createNoDataText = (id) => {
    let noDataText = '';
    if (id) {
      switch (id) {
        case ID_LISTA_ATIVIDADE:
          noDataText='Nenhuma atividade foi adicionada à lista.';
          break;
        case ID_LISTA_AFASTAMENTOS:
          noDataText='Nenhuma dedução foi adicionada à lista';
          break;
        case ID_LISTA_TEMPOS_CERTIFICADOS:
          noDataText='Nenhum tempo certificado foi adicionado à lista';
          break;
        case ID_LISTA_TEMPOS_ESPECIAIS:
          noDataText='Nenhum tempo especial foi adicionado à lista';
          break;
        case ID_LISTA_REMUNERACOES:
          noDataText='Nenhuma remuneração foi adicionada à lista';
          break;
        default:
          break;        
      }
    }
    return noDataText;
  }

  fetchInfo = {};

  handleChange = (changeObj, name) => {
    const id = this.props.id;
    let valor = changeObj.value;
    switch (id) {
      case ID_LISTA_AFASTAMENTOS:
        let { ctcAtividadeAfastamento } = { ...this.state };
        this.setState({
          ctcAtividadeAfastamento: {
            ...ctcAtividadeAfastamento,
            [name]: valor,
          },
        });
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        let { ctcAtividadeTempoCertificado } = { ...this.state };
        this.setState({
          ctcAtividadeTempoCertificado: {
            ...ctcAtividadeTempoCertificado,
            [name]: valor,
          },
        });
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        let { ctcAtividadeTempoEspecial } = { ...this.state };
        this.setState({
          ctcAtividadeTempoEspecial: {
            ...ctcAtividadeTempoEspecial,
            [name]: valor,
          },
        });
        break;
      case ID_LISTA_REMUNERACOES:
        let { remuneracoesPreenchidas } = { ...this.state };
        let competenciaPreenchida = null;
        
        if(name.indexOf('-') !== -1) {
          competenciaPreenchida = {competencia: name, valor: changeObj.value};
          const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === name ));
          if (index !== -1) {
            remuneracoesPreenchidas.splice(index, 1);
          }
        }
        if(name.indexOf('-') !== -1) {
          const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === name ));
          if (index === -1) {
            remuneracoesPreenchidas.push(competenciaPreenchida);
          }
        }

        this.setState({
          [name]: changeObj.value,
          remuneracoesPreenchidas,
        });
        break;
      default:
        break;
    }
  }

  preencherColecaoAutomaticamente = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  atualizarListaRemuneracao = (changeObj, nome) => {
    this.setState({
      [nome]: changeObj,
    });
  }

  alteraListaAposExclusao = (lista) => {
    this.props.handleChange({ value: lista, isValid: lista.length > 0 }, this.determinarNomeListaAtividades());
  }

  createColunaDestinatarios = (cell, row) => {
    const lista = row.temposCertificados ? row.temposCertificados : [];
    const tamanho = row.temposCertificados ? row.temposCertificados.length : 0;
    const { destinacoes } = { ...this.props.statePrincipal.ctc };
    let retornos = [];

    lista.forEach((tempo) => {
      const index = destinacoes.findIndex(dest => (dest.indiceDestinacao === tempo.indiceDestinatario));
      if (index !== -1) {
        let destinacao = {nomeOrgao: destinacoes[index].nomeOrgao, codigoParticipante: destinacoes[index].codigoParticipante};
        retornos.push(destinacao);
      }
    });

    let possuiDestinatario1 = false;
    let possuiDestinatario2 = false;
    let possuiDestinatario3 = false;

    switch (tamanho) {
      case 1:
        possuiDestinatario1 = true;
        break;
      case 2:
        possuiDestinatario1 = true;
        possuiDestinatario2 = true;
        break;
      case 3:
        possuiDestinatario1 = true;
        possuiDestinatario2 = true;
        possuiDestinatario3 = true;
        break;
      default:
        break;
    }

    const destinatario1 = possuiDestinatario1 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>1.&nbsp;</span>{retornos[0].nomeOrgao} - {retornos[0].codigoParticipante}
      </Grid>
    ) : null;
    const destinatario2 = possuiDestinatario2 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>2.&nbsp;</span>{retornos[1].nomeOrgao} - {retornos[1].codigoParticipante}
      </Grid>
    ) : null;
    const destinatario3 = possuiDestinatario3 ? (
      <Grid cols="12 12 12 12" style={{ 'text-align': 'justify' }}>
        <span style={{ color: 'blue' }}>3.&nbsp;</span>{retornos[2].nomeOrgao} - {retornos[2].codigoParticipante}
      </Grid>
    ) : null;

    return (
      <React.Fragment>
        <div>
          {destinatario1}
          {destinatario2}
          {destinatario3}
        </div>
      </React.Fragment>
    );
  };

  montaColunasDefault = () => {
    const colunasDefault = [{
      id: 'dtInicio',
      label: 'Data de Início',
    },
    {
      id: 'dtFim',
      label: 'Data de Término',
    },
  ];

    return colunasDefault.slice();
  }

  montaColunasMatricula = () => {
    const colunasMatriculas = [{
      id: 'matricula',
      label: 'Matrícula',
    },
  ];
    return colunasMatriculas.slice();
  }

  montaColunasDestinatario = () => {
    const colunasDestinatarios = [{
      id: 'destinatario',
      label: 'Destinatário',
      dataFormat: this.createColunaDestinatarios,
    },
  ];
    return colunasDestinatarios.slice();
  }

  addTipoAfastamentoLabel = tipo => (
    listUtils.getObject(listUtils.tipoAfastamento, tipo).label
  )

  addTipoTempoEspecialLabel = tipo => (
    listUtils.getObject(listUtils.tipoTempoEspecial, tipo).label
  )

  addMesLabel = tipo => (
    listUtils.getObject(listUtils.meses, tipo).labelCompleto
  )

  addRemuneracaoLabel = valor => {
    let retorno = valor;
    if (retorno) {
      retorno = retorno.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 })
    }
    return retorno;
  }
  
  addLinkDadosRemuneracoes = (row) => {
    let mes = '';
    let ano = '';
    let competenciaFormat = '';
    if (row) {
      if (row.toString().indexOf('/') === -1) {
        competenciaFormat = row;
        ano = competenciaFormat;
      } else {
        mes = (Number(row.split('/')[0]));
        ano = (Number(row.split('/')[1]));
        if (mes === 13) {
          competenciaFormat = `13º/${ano}`;
        }else{
          competenciaFormat = `${listUtils.getObject(listUtils.meses, mes).label}/${ano}`;
        }
      }
    }
    return (
      <React.Fragment>
          <a href="#" onClick={() => this.exibirModalRemuneracoesPreenchidas(ano)}>{competenciaFormat}</a>
      </React.Fragment>
    );
  }

  montaColunasEspecificas = () => {
    const id = this.props.id;
    switch (id) {
      case ID_LISTA_ATIVIDADE:
        return [
          {
            id: 'nomeEmpregador',
            label: 'Nome do empregador',
          },
          {
            id: 'cargo',
            label: 'Cargo',
          },
          {
            id: 'diasContribuicaoBruto',
            label: 'Tempo bruto (dias)',
          }
        ];
      case ID_LISTA_AFASTAMENTOS:
        return [
          {
            id: 'tempoLiquidoCertificado',
            label: 'Tempo em dias',
          },
          {
          id: 'tipo',
          label: 'Tipo da dedução',
          dataFormat: this.addTipoAfastamentoLabel,
        }];
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        return [
          {
            id: 'nomeDestinacao',
            label: 'Destinação',
          },
          {
            id: 'tempoLiquidoCertificado',
            label: 'Tempo líquido (dias)',
          }
        ];
      case ID_LISTA_TEMPOS_ESPECIAIS:
        return [
          {
            id: 'tempoLiquidoCertificado',
            label: 'Tempo em dias',
          },
          {
            id: 'tipo',
            label: 'Tipo',
            dataFormat: this.addTipoTempoEspecialLabel,
          }
        ];
      case ID_LISTA_REMUNERACOES:
        return [
          {
              id: 'ano',
              label: 'Ano',
              dataFormat: this.addLinkDadosRemuneracoes,
            },
            {
              id: 'competenciaInicio',
              label: 'Competência inicial',
              dataFormat: this.addLinkDadosRemuneracoes,
            },
            {
              id: 'competenciaFim',
              label: 'Competência final',
              dataFormat: this.addLinkDadosRemuneracoes,
            },
        ]  
      default:
        return [{}];
    }
  };

  montaColunas = () => {
    const id = this.props.id;
    let atividadesTableHeader = null;
    if (id !== ID_LISTA_REMUNERACOES) {
      atividadesTableHeader = this.montaColunasDefault();
      if (id === ID_LISTA_ATIVIDADE) {
        atividadesTableHeader= atividadesTableHeader.concat(this.montaColunasMatricula());
        atividadesTableHeader= atividadesTableHeader.concat(this.montaColunasDestinatario());
      }
    }
    const colunasEspecificas = this.montaColunasEspecificas();
    if (id !== ID_LISTA_REMUNERACOES && colunasEspecificas) {
      atividadesTableHeader = atividadesTableHeader.concat(colunasEspecificas);
    } else {
      atividadesTableHeader = colunasEspecificas;
    }
    atividadesTableHeader.push({
      id: 'indice',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });
    return atividadesTableHeader;
  }

  exibirBotaoAlterar = () => (
    (this.props.statePrincipal !== 'criado' && ['novo', 'editar-rascunho', 'revisar-ctc'].includes(this.props.statePrincipal.acao))
  );

  exibirBotoesPadrao = () => (
    (this.props.statePrincipal !== 'criado' && ['novo', 'editar-rascunho', 'revisar-ctc'].includes(this.props.statePrincipal.acao))
  );

  exibirBotaoIncluir = () => (
    (!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao))
  );

  exibirBotaoDetalhar = () => (
    (['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao))
  );

  exibirModalRemuneracoesPreenchidas = (ano) => {
    this.setState({
      showModalExibirModalRemuneracoesPreenchidas: !this.state.showModalExibirModalRemuneracoesPreenchidas,
      anoEscolhido: ano,
    });
  }

  showModalAtividade = () => {
    const { destinacoes } = { ...this.props.statePrincipal.ctc };
    const { showModal } = { ...this.props.stateAtividade };
    const { exibirBotaoIncluirInicial } = { ...this.props.stateAtividade };

    if (destinacoes && destinacoes.length > 0) {
      this.props.validarCheckboxSegundaMatricula();
      this.props.verificarDesabilitarTodosOsBotoesAlterar(true);
      this.props.validarDatasInicioEFimAtividade();
      this.props.handleChange({ value: !showModal, isValid: true }, 'showModal');
      this.props.handleChange({ value: !exibirBotaoIncluirInicial, isValid: true }, 'exibirBotaoIncluirInicial');
    } else {
      trataMensagensErro(['É necessário possuir pelo menos um destinatário cadastrado para incluir uma atividade.']);
    }
  }

  determinarNomeListaAtividades = () => {
    const id = this.props.id;
    let nomeLista = '';
    switch (id) {
      case ID_LISTA_ATIVIDADE:
        nomeLista = 'atividades';
        break;
      case ID_LISTA_AFASTAMENTOS:
        nomeLista = 'afastamentos';
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        nomeLista = 'temposCertificados';
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        nomeLista = 'temposEspeciais';
      break;
      case ID_LISTA_REMUNERACOES:
        nomeLista = 'remuneracoes';
      break;
      default:
        break;
    }
    return nomeLista;
  }

  gerenciarDestinacao = (lista, operacao) => {
    const { destinacoes } = { ...this.props.statePrincipal.ctc };
    if (lista.length > 0 && destinacoes.length > 0) {
      destinacoes.forEach((destinacao) => {
        lista.forEach((tempoCertificado) => {
          if (operacao === 1) { // INCLUIR
            if (destinacao.nomeParticipante === tempoCertificado.nomeDestinacao) {
              this.props.desabilitarBotaoExcluirLinhaDestinacaoUtilizada(destinacao.indice);
              return;
            }
          }
          if (operacao === 3) { //EXCLUIR
            if (destinacao.nomeParticipante === tempoCertificado.nomeDestinacao) {
              this.props.habilitarBotaoExcluirLinhaDestinacaoUtilizada(destinacao.indice);
              return;
            }
          }
        });
      });
    }
  }

  filtrarRemuneracoesParaVisualizar = (remuneracoes, ano) => {
    let retorno = [];
    if (remuneracoes && ano) {
      retorno = remuneracoes.filter(r => r.ano === ano);
    }
    return retorno;
  }

  formatarMoeda = (valor) => {
    if (typeof (valor) !== 'number') {
      let aux = valor;
      aux = valor.replace(/\./g, '').replace(/,/g, '.');
      return Number(aux);
    }
    return valor;
  }

  criarRemuneracoes = (remuneracoes) => {
    let retorno = [];
    remuneracoes.forEach((item) => {
      let competencia = this.formatarCompetencia(`${item.mes}-${item.ano}`);
      let valor = {
        competencia: competencia,
        valor: item.valor,
      };
      retorno.push(valor);
    });
    return retorno;
  }

  carregarRemuneracoesCadastradas = () => {
    const { remuneracoesAtividade } = { ...this.props.stateAtividade };
    let { remuneracoes } = { ...this.props.ctcAtividade };
    let { anosQuePossuemAlgumaRemuneracao } = { ...this.state };
    let retorno = [];
    if (remuneracoes !== null) {
      remuneracoes.forEach((remuneracao) => {
        const competencia = this.formatarCompetencia(`${remuneracao.mes}/${remuneracao.ano}`);
        let mesCompetencia = null;
        let anoCompetencia = null;
        let siglaMoedaCompetencia = null;
        let valorRemuneracao = null;
        let tipoMoedaCompetencia = null;
        const index = remuneracoesAtividade.moedasCompetencia.findIndex(r => (r.competencia === competencia));
        if (index !== -1) {
          mesCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(0, 2), 10);
          anoCompetencia = parseInt(remuneracoesAtividade.moedasCompetencia[index].competencia.substring(3, 7), 10);
          siglaMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].sigla;
          valorRemuneracao = this.formatarMoeda(remuneracao.valor);
          tipoMoedaCompetencia = remuneracoesAtividade.moedasCompetencia[index].tipoMoeda;
          const indiceRemuneracao = remuneracoes.findIndex(r => (r.mes === mesCompetencia && r.ano === anoCompetencia));
          if (indiceRemuneracao === -1) {
            const ctcAtividadeRemuneracao = {
              mes: mesCompetencia,
              ano: anoCompetencia,
              tipoMoeda: tipoMoedaCompetencia,
              siglaMoeda: siglaMoedaCompetencia,
              valor: valorRemuneracao,
            };
            remuneracoes.push(ctcAtividadeRemuneracao);
          }
          const indiceAno = anosQuePossuemAlgumaRemuneracao.findIndex(a => (a.ano === anoCompetencia));
          if (indiceAno === -1) {
            const ano = {
              ano: anoCompetencia,
            }
            anosQuePossuemAlgumaRemuneracao.push(ano);
          }
        }
      });

      retorno = this.criarRemuneracoes(remuneracoes);
      anosQuePossuemAlgumaRemuneracao = recuperarAnosQuePossuemAlgumaRemuneracao(anosQuePossuemAlgumaRemuneracao, remuneracoes);
      this.props.handleChange({ value: anosQuePossuemAlgumaRemuneracao, isValid: anosQuePossuemAlgumaRemuneracao.length > 0 }, 'anosQuePossuemAlgumaRemuneracao');

      this.setState({
        remuneracoesPreenchidas: retorno,
        remuneracoesHistory: retorno,
      });
    }
  }

  render() {
    const header = this.montaColunas();
    const id = this.props.id;
    
    let opcoes = {
      hideSizePerPage: true,
      insertBtn: this.createCustomInsertButton,
      noDataText: this.createNoDataText(id),
      sizePerPage: 3,
    };

    let lista = [];
    let listaIndexada = [];
    const { matricula1 } = { ...this.props.statePrincipal.ctc };
    const { matricula2 } = { ...this.props.statePrincipal.ctc }

    switch (id) {
      case ID_LISTA_ATIVIDADE:
        lista = this.props.statePrincipal.ctc.atividades;
        break;
      case ID_LISTA_AFASTAMENTOS:
        lista = this.props.ctcAtividade.afastamentos;
        break;
      case ID_LISTA_TEMPOS_CERTIFICADOS:
        lista = this.props.ctcAtividade.temposCertificados;
        break;
      case ID_LISTA_TEMPOS_ESPECIAIS:
        lista = this.props.ctcAtividade.temposEspeciais;
        break;
      case ID_LISTA_REMUNERACOES:
        lista = this.props.ordenarRemuneracoesPorAno(this.props.stateAtividade.anosQuePossuemAlgumaRemuneracao);
        break;
      default:
        break;
    }

    if (lista) {
      listaIndexada = lista.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.indice = i;
        itemIndexado.matricula = (item.pertenceSegundaMatricula !== null && item.pertenceSegundaMatricula === 1) ? matricula2 : matricula1;
        return itemIndexado;
      });
    }

    return (
      <React.Fragment>
        <DataGridCustom title={this.props.titulo} retirarLinhaSeparadora={this.props.retirarLinhaSeparadora}>
          <div className="row">
            <Grid cols="12 12 12 12">
              <Table
                bordered
                // data={this.props.ordenarLista(listaIndexada)}
                data={this.props.id === ID_LISTA_ATIVIDADE ?
                  this.props.ordenarAtividadesPorMatriculaEDataInicio(listaIndexada) :
                  this.props.ordenarLista(listaIndexada)}
                insertRow={this.exibirBotaoIncluir}
                options={opcoes}
                listaTableHeader={header}
                pagination
                fetchInfo={this.fetchInfo}
              />
            </Grid>
          </div>
          </DataGridCustom>
          {this.state.showModal ? (
            <ModalTemposERemuneracoes
              id={this.props.id}
              ctcAtividade={this.props.ctcAtividade}
              showModal={this.state.showModal}
              statePrincipal={this.props.statePrincipal}
              stateAtividade={this.props.stateAtividade}
              anoEscolhido={this.state.anoEscolhido}
              remuneracoesPreenchidas={this.state.remuneracoesPreenchidas}
              remuneracoesHistory={this.state.remuneracoesHistory}
              anosQuePossuemAlgumaRemuneracao={this.props.anosQuePossuemAlgumaRemuneracao}
              operacaoRemuneracao={this.state.operacaoRemuneracao}
              atividade={this.determinarObjetoAtividade()}
              determinarConcomitancias={this.props.determinarConcomitancias}
              resetAtividades={this.resetAtividades}
              determinarNomeListaAtividades={this.determinarNomeListaAtividades}
              escolherLista={this.escolherLista}
              atualizarListaRemuneracao={this.atualizarListaRemuneracao}
              gerenciarDestinacao={this.gerenciarDestinacao}
              preencherColecaoAutomaticamente={this.preencherColecaoAutomaticamente}
              handleChangeCtcAtividade={this.props.handleChange}
              handleChange={this.handleChange}
              montarListaDestinacaoTempoCertificado={this.props.montarListaDestinacaoTempoCertificado}
              ordenarLista={this.props.ordenarLista}
              calcularTempoLiquidoCertificado={this.props.calcularTempoLiquidoCertificado}
              verificarMudancaTempoLiquidoCertificado={this.props.verificarMudancaTempoLiquidoCertificado}
              tratarConcomitancias={this.props.tratarConcomitancias}
            />
          ) : ''}
          {this.state.showModalExibirModalRemuneracoesPreenchidas ?
            <ModalExibirModalRemuneracoesPreenchidas
              showModalExibirModalRemuneracoesPreenchidas={this.state.showModalExibirModalRemuneracoesPreenchidas}
              ordenarLista={this.props.ordenarLista}
              ordenarCompetenciasRemuneracao={this.props.ordenarCompetenciasRemuneracao}
              remuneracoes={this.filtrarRemuneracoesParaVisualizar(this.props.ctcAtividade.remuneracoes, this.state.anoEscolhido)}
              exibirModalRemuneracoesPreenchidas={this.exibirModalRemuneracoesPreenchidas}
            />
          : ''}
      </React.Fragment>
    );
  }
}

MultiplasAtividades.propTypes = {
  id: PropTypes.number.isRequired,
  statePrincipal: PropTypes.objectOf(PropTypes.object).isRequired,
  stateAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  tempoAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  ctcAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  titulo: PropTypes.string.isRequired,
  retirarLinhaSeparadora: PropTypes.bool.isRequired,
  validarDatasInicioEFimAtividade: PropTypes.func.isRequired,
  ordenarLista: PropTypes.func.isRequired,
  ordenarRemuneracoesPorAno: PropTypes.func.isRequired,
  ordenarListaRemuneracoes: PropTypes.func.isRequired,
  ordenarAtividadesPorMatriculaEDataInicio: PropTypes.func.isRequired,
  desabilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func.isRequired,
  habilitarBotaoExcluirLinhaDestinacaoUtilizada: PropTypes.func.isRequired,
  desabilitarCheckboxMatriculaEDestinacao: PropTypes.func.isRequired,
  habilitarCheckboxMatriculaEDestinacao: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleExcluirAtividade: PropTypes.func.isRequired,
  handleCarregarVisualizacaoAtividade: PropTypes.func.isRequired,
  handleCarregarAlteracaoAtividade: PropTypes.func.isRequired,
  montarListaDestinacaoTempoCertificado: PropTypes.func.isRequired,
  validarCheckboxSegundaMatricula: PropTypes.func.isRequired,
  verificarDesabilitarTodosOsBotoesAlterar: PropTypes.func.isRequired,
  validarDatasInicioEFimAtividade: PropTypes.func.isRequired,
  calcularTempoLiquidoCertificado: PropTypes.func.isRequired,
  tratarConcomitancias:  PropTypes.func.isRequired,
};

export default (MultiplasAtividades);



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/MultiplasAtividades.jsx